import React         from 'react';
import ReactDOM      from 'react-dom';
import AudioRecorder from 'audio-recorder-polyfill';
import CssBaseline   from '@mui/material/CssBaseline';

import LandingPageIndex from 'pages/LandingPage';

import AppTheme from 'components/App/Theme';

window.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('landing-page-wrapper');
  if (!container) return false;

  ReactDOM.render(
    <AppTheme>
      <CssBaseline />
      <LandingPageIndex />
    </AppTheme>,
    container,
  );

  return true;
});

if (typeof MediaRecorder === 'undefined') {
  window.MediaRecorder = AudioRecorder;
}
